// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V_KX","left":"styles_left__A8nqp"};